const baseConfig = {
  environment: 'test',
  // 接口请求地址
  BASE_URL: 'http://www.ctc-sh.com/zcoa',
  publishHost: window.location.origin
}

const config = {
  local: {
    ...baseConfig,
  // 接口请求地址
  BASE_URL: 'http://www.ctc-sh.com/zcoa',
  publishHost: 'http://www.ctc-sh.com/zcoa'
  },
  mock: {
    ...baseConfig,
  },
  test: {
    ...baseConfig,
  },
  prod: {
    ...baseConfig,
    environment: 'prod',
    // 接口请求地址
    BASE_URL: 'http://www.ctc-sh.com/zcoa',
  }
}

export default config[process.env.REACT_APP_ENV] || config.test  as typeof config.local
